import { InfoEnum } from '../enumerators/messages.enum';

export class Info {
    public type: InfoEnum = InfoEnum.Normal;
    public icon: string = "";
    public message: string = "";
    public title: string = "";
    public size: number = 40;

    constructor(init?: Partial<Info>) {
        Object.assign(this, init);
    }

}
